export default __webpack_public_path__ + "static/media/jordklot.922809d6.svg";